"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESERVED_EVENTS = void 0;
exports.RESERVED_EVENTS = new Set([
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener",
]);
